import React, { useEffect, useState } from 'react';
import styles from './edit-general-info.module.scss';
import { store } from 'react-notifications-component';
import {
  InputText,
  InputTextType
} from '../../../../../shared/components/core-ui/input-text/input-text.component';
// @ts-ignore
import { CKEditor } from '@ckeditor/ckeditor5-react';
// @ts-ignore
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { FormElementData } from '../../../../../shared/interfaces/form-element-data.interface';
import Button, {
  ButtonSize
} from '../../../../../shared/components/core-ui/button/button.component';
import useWindowResizer from '../../../../../shared/hooks/window-resizer/window-resizer.hook';
import { UnitTypeUiModel } from '../../../../../shared/ui-models/unit-type.ui-model';
import { PUBLIC_PATH } from '../../../../../shared/config/routes-config';

export interface EditGeneralInfoProps {
  data: {
    unitType: UnitTypeUiModel | undefined;
  };
  config: {
    isLoading: boolean;
  };
  eventHandlers: {
    submitHandler: (data: Partial<UnitTypeUiModel>) => void;
  };
}

/**
 * functional component EditGeneralInfoArabic
 * @param {EditGeneralInfoProps} holding question text
 */
export const EditGeneralInfoArabic: React.FC<EditGeneralInfoProps> = ({
  data,
  config,
  /*  */ eventHandlers
}) => {
  const isMobileView = useWindowResizer();

  const [newHouseRulesAr, setNewHouseRulesAr] = useState<FormElementData<string | undefined>>({
    value: undefined,
    isValid: false,
    changed: false
  });
  const [newOnboardingMessageAr, setNewOnboardingMessageAr] = useState<
    FormElementData<string | undefined>
  >({
    value: undefined,
    isValid: false,
    changed: false
  });

  const [newDescriptionAr, setNewDescriptionAr] = useState<FormElementData<string | undefined>>({
    value: undefined,
    isValid: false,
    changed: false
  });
  const [newWebSiteDescriptionAr, setNewWebSiteDescriptionAr] = useState<
    FormElementData<string | undefined>
  >({
    value: undefined,
    isValid: false,
    changed: false
  });

  const [newNameAr, setNewNameAr] = useState<FormElementData<string | undefined>>({
    value: undefined,
    isValid: false,
    changed: false
  });

  useEffect(() => {
    return () => {
      store.removeNotification('general-info-failed');
      store.removeNotification('general-info-success');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (data.unitType) {
      setNewNameAr({
        value: data.unitType?.nameAr || '',
        isValid: false,
        changed: false
      });
      setNewDescriptionAr({
        value: data.unitType.descriptionAr || '',
        isValid: false,
        changed: false
      });
      setNewWebSiteDescriptionAr({
        value: data.unitType.websiteDescriptionAr || '',
        isValid: false,
        changed: false
      });
      setNewHouseRulesAr({
        value: data.unitType.houseRulesAr || '',
        isValid: false,
        changed: false
      });
      setNewOnboardingMessageAr({
        value: data.unitType.onboardingMessageAr || '',
        isValid: false,
        changed: false
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.unitType]);

  const handleGeneralInfoSubmit = () => {
    const updatedData: Partial<UnitTypeUiModel> = {};

    if (newHouseRulesAr.changed && newHouseRulesAr.value) {
      updatedData['houseRulesAr'] = newHouseRulesAr.value;
    }
    if (newOnboardingMessageAr.changed && newOnboardingMessageAr.value) {
      updatedData['onboardingMessageAr'] = newOnboardingMessageAr.value;
    }
    if (newNameAr.changed && newNameAr.value) {
      updatedData['nameAr'] = newNameAr.value;
    }
    if (newDescriptionAr.changed && newDescriptionAr.value) {
      updatedData['descriptionAr'] = newDescriptionAr.value;
    }
    if (newWebSiteDescriptionAr.changed && newWebSiteDescriptionAr.value) {
      updatedData['websiteDescriptionAr'] = newWebSiteDescriptionAr.value;
    }
    eventHandlers.submitHandler(updatedData);
  };

  return (
    <div className={styles['general-info-container']} style={{ direction: 'rtl' }}>
      {config.isLoading ? (
        <div className={styles['general-info-container__loader']}>
          <img src={`${PUBLIC_PATH}/assets/svgs/loader.svg`} alt="loader" />
        </div>
      ) : (
        <>
          <div
            className={styles['general-info-container__sub-title']}
            style={{ textAlign: 'right', direction: 'rtl' }}
          >
            المعلومات العامة
          </div>
          <div className={styles['general-info-container__wrapper']} style={{ direction: 'rtl' }}>
            <div style={{ marginBottom: '0.5rem', fontWeight: '500', textAlign: 'right' }}>
              الاسم
            </div>
            <div className={styles['general-info-container__field']}>
              <InputText
                config={{
                  autoFocus: false,
                  type: InputTextType.text,
                  required: true,
                  disabled: false
                }}
                data={{
                  placeholder: 'اسم نوع الوحدة',
                  errorMessage: 'يجب أن يكون اسم المشروع 6 أحرف على الأقل',
                  value: newNameAr.value || ''
                }}
                eventHandlers={{
                  onChangeHandler: (value) => {
                    setNewNameAr({
                      value,
                      isValid: true,
                      changed: true
                    });
                  }
                }}
              />
            </div>
            {newWebSiteDescriptionAr.value !== undefined && (
              <>
                <div style={{ marginBottom: '0.5rem', fontWeight: '500', textAlign: 'right' }}>
                  وصف الموقع الإلكتروني
                </div>
                <div className={styles['general-info-container__field']}>
                  <CKEditor
                    editor={ClassicEditor}
                    data={newWebSiteDescriptionAr?.value}
                    onChange={(_event: any, editor: any) => {
                      const newData: string = editor.getData();
                      setNewWebSiteDescriptionAr({ value: newData, isValid: true, changed: true });
                    }}
                  />
                </div>
              </>
            )}
            {newDescriptionAr.value !== undefined && (
              <>
                <div style={{ marginBottom: '0.5rem', fontWeight: '500', textAlign: 'right' }}>
                  الوصف
                </div>
                <div className={styles['general-info-container__field']}>
                  <CKEditor
                    editor={ClassicEditor}
                    data={newDescriptionAr.value}
                    onChange={(_event: any, editor: any) => {
                      const newData: string = editor.getData();
                      setNewDescriptionAr({ value: newData, isValid: true, changed: true });
                    }}
                  />
                </div>
              </>
            )}
            {newHouseRulesAr.value !== undefined && (
              <>
                <div style={{ marginBottom: '0.5rem', fontWeight: '500', textAlign: 'right' }}>
                  قواعد المنزل
                </div>
                <div className={styles['general-info-container__field']}>
                  <CKEditor
                    editor={ClassicEditor}
                    data={newHouseRulesAr.value}
                    onChange={(event: any, editor: any) => {
                      const newData: string = editor.getData();
                      setNewHouseRulesAr({ value: newData, isValid: true, changed: true });
                    }}
                  />
                </div>
              </>
            )}
            {newOnboardingMessageAr.value !== undefined && (
              <>
                <div style={{ marginBottom: '0.5rem', fontWeight: '500', textAlign: 'right' }}>
                  رسالة الترحيب
                </div>
                <div className={styles['general-info-container__field']}>
                  <CKEditor
                    editor={ClassicEditor}
                    data={newOnboardingMessageAr.value}
                    onChange={(_event: any, editor: any) => {
                      const newData: string = editor.getData();
                      setNewOnboardingMessageAr({ value: newData, isValid: true, changed: true });
                    }}
                  />
                </div>
              </>
            )}
            <div className={styles['general-info-container__actions']} style={{ direction: 'rtl' }}>
              <Button
                disabled={
                  (newHouseRulesAr.value === '' || !newHouseRulesAr.changed) &&
                  (newOnboardingMessageAr.value === '' || !newOnboardingMessageAr.changed) &&
                  (newNameAr.value === '' || !newNameAr.changed) &&
                  (newDescriptionAr.value === '' || !newDescriptionAr.changed) &&
                  (newWebSiteDescriptionAr.value === '' || !newWebSiteDescriptionAr.changed)
                }
                onClick={handleGeneralInfoSubmit}
                tracking={{
                  event: 'record_saved',
                  entity: 'unit_type',
                  action: 'update',
                  outcome: 'success'
                }}
                size={isMobileView ? ButtonSize.full : ButtonSize.medium}
              >
                تحديث
              </Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default EditGeneralInfoArabic;
